import { useTheme } from '@mui/material'

export const GradientAreaFill = () => {
    const theme = useTheme()

    return (
        <defs>
            <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                <stop
                    offset="0%"
                    stopColor={
                        (theme.palette.error as any)._states.focusVisible
                    }
                    stopOpacity={0.8}
                />
                <stop
                    offset="100%"
                    stopColor={theme.palette.background.default}
                    stopOpacity={0}
                />
            </linearGradient>
        </defs>
    )
}
